<template>
  <el-container class="captcha-box">
    <el-button type="primary" class="send-btn" :size="props.size" :disabled="!canSend" @click="showPopup" plain>
      {{ btnText }}
    </el-button>


<!---  <button class="custom-button" type="button" @click="showPopup">按钮A</button> -->
  <div v-if="showPopupFlag" class="popup" id="myDiv">
   <!---  <div class="input-text">请输入验证码</div>-->
    <h3 class="unselectable">{{ captcha }}</h3>
    <input type="text" class="input-text2" v-model="inputCode" placeholder="请输入上面字母">
    <button class="check-button" @click="checkCode" >提交</button>
      <button class="close-button" @click="closePopup">X</button>

  </div>


    <el-dialog
        v-model="showCaptcha"
        :close-on-click-modal="true"
        :show-close="false"
        style="width:90%;max-width: 360px;"
    >
      <captcha-plus
          :max-dot="maxDot"
          :image-base64="imageBase64"
          :thumb-base64="thumbBase64"
          width="300"
          @close="showCaptcha = false"
          @refresh="handleRequestCaptCode"
          @confirm="handleConfirm"
      />

    </el-dialog>
  </el-container>
</template>

<script setup>
// 发送短信验证码组件
import {ref} from "vue";
import lodash from 'lodash'
import {validateMobile} from "@/utils/validate";
import {ElMessage} from "element-plus";
import {httpGet, httpPost} from "@/utils/http";
import CaptchaPlus from "@/components/CaptchaPlus.vue";

const props = defineProps({
  mobile: String,
  size: String,
});
const btnText = ref('发送验证码')
const canSend = ref(true)
const showCaptcha = ref(false)
const maxDot = ref(5)
const imageBase64 = ref('')
const thumbBase64 = ref('')
const captKey = ref('')
const dots = ref(null)




//<!-------xiya.js部分------>
const showPopupFlag = ref(false);
const captcha = ref("");
const inputCode = ref("");


function showPopup() {  
  if (!validateMobile(props.mobile)) {
    return ElMessage.error("请输入合法的手机号")
  }

    //const data = res.data
    //imageBase64.value = data.image
    //thumbBase64.value = data.thumb
    //captKey.value = data.key
    captKey.value = "asdasf" //虚值——>原验证

  captcha.value = generateCaptcha();//xiya验
  showPopupFlag.value = true;
}

function generateCaptcha() {
  const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  for (let i = 0; i < 4; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars[randomIndex];
  }

  return result;
}

function checkCode() {
  if (inputCode.value.toLowerCase() === captcha.value.toLowerCase()) {
    //ElMessage.success('人机验证成功')
    closePopup();
    sendMsg();


  }  else {
    //alert("输入错误");
    ElMessage.error('人机校验失败，请重试')
    inputCode.value = "";
    event.preventDefault();
    captcha.value = generateCaptcha(); // 生成新的验证码
  }
}

function closePopup() {
  showPopupFlag.value = false;
  inputCode.value = "";
}



//xiya js部分-end-----------------





//  接受发来的人机验证图
const handleRequestCaptCode = () => {

  httpGet('/api/captcha/get').then(res => {
    const data = res.data
    imageBase64.value = data.image
    thumbBase64.value = data.thumb
    captKey.value = data.key
  }).catch(e => {
    ElMessage.error('获取人机验证数据失败：' + e.message)
  })
}



// 校验
const handleConfirm = (dots) => {
  if (lodash.size(dots) <= 0) {
    return ElMessage.error('请进行人机验证再操作')
  }

  let dotArr = []
  lodash.forEach(dots, (dot) => {
    dotArr.push(dot.x, dot.y)
  })
  dots.value = dotArr.join(',')
  httpPost('/api/captcha/check', {
    dots: dots.value,
    key: captKey.value
  }).then(() => {
    // ElMessage.success('人机验证成功')
    showCaptcha.value = false
    sendMsg()     //  （4）发送
  }).catch(() => {
    ElMessage.error('人机验证失败')
    handleRequestCaptCode()
  })
}


//  拉取验证码
const loadCaptcha = () => {
  if (!validateMobile(props.mobile)) {
    return ElMessage.error("请输入合法的手机号")
  }

  showCaptcha.value = true
  handleRequestCaptCode() // 每次点开都刷新验证码
}



const sendMsg = () => {
  if (!canSend.value) {
    return
  }

  canSend.value = false
  httpPost('/api/sms/code', {mobile: props.mobile, key: captKey.value, dots: dots.value}).then(() => {
    ElMessage.success('短信发送成功')
    let time = 120
    btnText.value = time
    const handler = setInterval(() => {
      time = time - 1
      if (time <= 0) {
        clearInterval(handler)
        btnText.value = '重新发送'
        canSend.value = true
      } else {
        btnText.value = time
      }
    }, 1000)
  }).catch(e => {
    canSend.value = true
    ElMessage.error('短信发送失败：' + e.message)
  })
}

</script>

<style lang="stylus">

.captcha-box {
  .send-btn {
    width: 100%;
  }

  .el-dialog {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      //padding 0
    }
  }
}


.close-button {
  position: absolute;
  top: 3px; /* 调整取消按钮距离顶部的距离 */
  right: 3px; /* 调整取消按钮距离右侧的距离 */
  bottom: 10px;
  //padding: 5px 10px; /* 调整取消按钮的大小 */
  font-size: 10px; /* 调整取消按钮的字体大小 */
  width: 30px; /* 设置按钮的宽度为100像素 */
  height: 20px; /* 设置按钮的高度为40像素 */
}
.input-text {
  font-size: 18px; /* 调整输入文本的字体大小 */
  color: #ffffff; /* 设置字体颜色为白色 */


}
.input-text2 {
  height: 20px;
  font-size: 12px; /* 调整输入文本的字体大小 */
  //color: #ffffff; /* 设置字体颜色为白色 */
  
}
.check-button {

  bottom: 3px;
  color: red; /* 设置按钮B的字体颜色为浅灰色 */
  font-size: 12px; /* 调整输入文本的字体大小 */
  height: 26px;
}

</style>